import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

import type { CommissionBannerTone } from "./CommissionBanner.types";

export const root =
  (tone: CommissionBannerTone): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    px: { xs: 2, sm: 3 },
    py: 1.75,
    bgcolor: alpha(theme.palette[tone].main, 0.06),
    borderBottom: `1.5px solid ${theme.palette[tone].main}`,
  });

export const iconWrap =
  (tone: CommissionBannerTone): SxProps<Theme> =>
  (theme) => ({
    width: 40,
    height: 40,
    borderRadius: 1.5,
    bgcolor: alpha(theme.palette[tone].main, 0.12),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  });

export const content: SxProps<Theme> = {
  flex: 1,
  minWidth: 200,
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
};

export const message =
  (tone: CommissionBannerTone): SxProps<Theme> =>
  () => ({
    fontSize: "0.84375rem",
    fontWeight: 700,
    color: `${tone}.main`,
  });


export const metaText: SxProps<Theme> = {
  fontSize: "0.75rem",
  fontWeight: 700,
  color: "text.secondary",
};

